export default __webpack_public_path__ + "static/media/nonnatuscoffee.8c5a3e64.PNG";